import './index.scss';

import { searchBarGa } from '../ga/index.js';

class SerpSearch {
    constructor() {
        this.disabled = false;
    }

    /**
     * Decorate a serp search bar
     *
     * @param {HTMLElement} element the form element or an ancestor.
     * @param {Boolean} hunt Whether or not to search decendents for the form element
     */
    decorate(element, hunt) {

        if(hunt) {
            element = element.querySelector('[data-serp-search-bar-form]');
        }

        ['change', 'paste', 'keyup', 'keydown', 'submit'].map(eventType => {
            element.addEventListener(eventType, event => {

                if(this.disabled) {
                    event.preventDefault();
                    return false;
                }
                if(event.key === 'Enter' || event.keyCode === 13 || event.type === 'submit') {
                    event.preventDefault();

                    if (!this.disabled && element.querySelector('[data-serp-search-bar-terms]').value !== '' ) {
                        searchBarGa();
                        element.submit();
                        this.disable(element);
                        setTimeout(() => this.enable(element), 2000);
                    }
                }
            })
        });

    }

    disable(element) {
        if(!this.disabled && element) {
            //element.querySelector('[data-serp-search-bar-terms]').setAttribute('disabled', '');

            this.disabled = true;
        }
    }

    enable(element) {
        if(this.disabled && element) {
            //element.querySelector('[data-serp-search-bar-terms]').removeAttribute('disabled');

            this.disabled = false;
        }
    }
}


function decorateSearchBars() {
    const searchBarList = Array.from(document.querySelectorAll('[data-serp-search-bar]'));

    const serpSearch = new SerpSearch();

    if(searchBarList.length > 0) {

        const input = searchBarList[0].querySelector('[data-serp-search-bar-terms]');
        if(input) {
            input.focus();
        }

        for(let b in searchBarList) {
            serpSearch.decorate(searchBarList[b], true);
        }
    }
}

export default decorateSearchBars;
